// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcbceb8a","355":"889b63fe","389":"1f4bdd68","453":"8e46b5d3","732":"2c701386","857":"8f626a2a","977":"c9c1bd5e"}[chunkId] + ".chunk.js";
};